export interface ILocation {
  id: string;
  description: string;
}
